import React, { Component } from "react";

import cx from "classnames";

import { Button } from "components/base";
import Nav from "components/Nav";

interface Props {
  errorTitle: string;
  errorMessage: string;
  buttonLabel: string;
  buttonLink?: string;
  buttonOnClick?(): void;
  showNavigation: boolean;
}

const defaultProps = {
  showNavigation: false
};

class ErrorPage extends Component<Props> {
  static defaultProps = defaultProps;

  render() {
    const {
      errorTitle,
      errorMessage,
      buttonLabel,
      buttonLink,
      buttonOnClick,
      showNavigation
    } = this.props;

    return (
      <div className="ErrorPage bg-color-gray-lighter flex flex-col justify-center">
        <div className="App__border fixed t0 b0 l0 r0 vw100 vh100 z-overlay events-none" />
        {!showNavigation && <Nav errorPage={true} />}
        <div
          className={cx(
            "ErrorPage__container mxauto color-gray-darker flex flex-col items-center justify-center",
            {
              "ErrorPage__container--page-not-found": showNavigation
            }
          )}
        >
          <h1 className="mb1_5 text-md gt-america text-center uppercase">
            {errorTitle}
          </h1>
          <span className="ErrorPage__message mxauto pt-serif">
            {errorMessage}
          </span>
          {buttonLink ? (
            <Button
              containerClassName="w100 flex justify-center"
              className="ErrorPage__button mt3 mb4 bg-color-orange color-white uppercase gt-america text-sm"
              ariaLabel={buttonLabel}
              label={buttonLabel}
              variant="primary"
              to={buttonLink}
            />
          ) : (
            <Button
              className="ErrorPage__button mt3 mb8 bg-color-orange color-white uppercase text-sm"
              ariaLabel={buttonLabel}
              label={buttonLabel}
              variant="primary"
              onClick={buttonOnClick}
            />
          )}
        </div>
      </div>
    );
  }
}

export default ErrorPage;
